<template>
  <div class="flex" v-if="dummyInfo">
    <vs-alert active="true" color="danger">{{ dummyInfo }}</vs-alert>
  </div>
</template>

<script>

export default {
  name: 'DummyBar',
  computed: {
    dummyInfo () {
      if(this.$store.state.currentUser){
        if(this.$store.state.currentUser.dummyInfo){
          const { email } = this.$store.state.currentUser.dummyInfo;
          return `เข้าใช้งานด้วยผู้ใช้งาน: ${email}`
        } else {
          return null
        }
      }else{
        return null
      }
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    currentUser () {
      return this.$store.state.currentUser
    },
    currentUserPhoto () {
      return this.$store.getters['getCurrentUserPhoto']
    },

  },
}

</script>
